import React from "react"

export default function BplsTimeIcon(props) {
  const {
    viewBox = "0 0 947.000000 858.000000",
    fill = "#000000",
    width = "947.000000pt",
    height = "858.000000pt"
  } = props
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,858.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M5104 8551 c-62 -28 -89 -73 -89 -146 0 -113 66 -164 213 -165 l83 0
-3 -137 -3 -138 -50 -2 c-108 -6 -357 -36 -485 -59 -445 -81 -914 -255 -1300
-483 l-85 -50 -72 112 c-40 62 -73 114 -73 117 0 3 31 24 69 48 84 52 113 93
113 162 0 93 -64 160 -154 160 -66 0 -57 5 -456 -257 -192 -126 -212 -147
-212 -229 0 -65 29 -111 90 -142 62 -32 104 -25 197 33 41 25 77 45 78 43 12
-12 145 -220 145 -226 0 -4 -48 -46 -107 -93 -395 -316 -746 -728 -982 -1154
-70 -126 -77 -171 -38 -239 31 -55 78 -78 148 -74 78 5 105 29 169 145 216
393 565 800 925 1082 526 412 1116 660 1805 757 159 23 707 26 870 6 793 -100
1464 -408 2052 -939 590 -533 1007 -1296 1137 -2078 39 -236 46 -327 46 -615
0 -289 -7 -384 -46 -615 -154 -917 -666 -1750 -1423 -2317 -674 -504 -1500
-756 -2348 -717 -914 41 -1764 416 -2413 1064 -248 246 -410 463 -635 847 -39
66 -88 98 -149 98 -92 0 -161 -69 -161 -162 0 -55 75 -195 225 -418 469 -700
1128 -1218 1928 -1516 600 -223 1297 -296 1942 -203 1290 187 2412 999 2993
2165 352 705 487 1502 386 2279 -132 1028 -660 1963 -1471 2608 -62 49 -113
92 -113 95 0 4 133 216 145 230 1 1 37 -19 80 -45 67 -41 86 -48 131 -48 89 0
154 67 154 159 0 79 -22 104 -182 209 -464 303 -424 281 -493 275 -90 -8 -145
-68 -145 -158 0 -70 25 -108 106 -159 40 -25 73 -49 73 -53 1 -7 -122 -201
-139 -221 -4 -4 -47 15 -96 44 -511 295 -1133 490 -1674 524 -52 3 -114 8
-137 11 l-43 5 0 135 0 134 83 0 c66 0 92 5 127 23 115 57 123 202 17 281 -27
20 -41 21 -370 24 -317 2 -345 1 -383 -17z"
        />
        <path
          d="M5205 7049 c-484 -42 -997 -220 -1401 -485 -97 -64 -119 -98 -112
-179 8 -96 74 -151 172 -143 42 4 68 16 146 67 126 82 384 209 540 265 143 51
366 107 520 132 140 22 531 30 687 14 420 -42 830 -184 1196 -414 106 -67 109
-68 166 -64 66 5 100 25 132 81 26 47 23 124 -8 165 -42 57 -288 204 -504 302
-144 65 -429 161 -579 194 -308 68 -648 91 -955 65z"
        />
        <path
          d="M7105 5845 c-16 -8 -280 -268 -586 -577 l-556 -562 -79 41 c-329 170
-726 113 -989 -142 -428 -415 -315 -1126 221 -1386 122 -59 217 -81 359 -82
131 -2 229 16 334 58 292 119 499 394 529 705 17 173 -10 320 -89 477 l-51
103 553 561 c305 308 560 572 568 586 19 36 10 131 -14 166 -42 57 -138 83
-200 52z m-1491 -1340 c152 -40 279 -142 346 -279 48 -98 64 -175 57 -277 -11
-137 -68 -252 -175 -351 -208 -192 -525 -185 -727 17 -209 209 -208 540 0 749
131 130 327 186 499 141z"
        />
        <path
          d="M952 5033 c-91 -45 -115 -165 -50 -248 44 -57 20 -55 881 -55 l794 0
33 23 c57 38 75 71 75 137 0 63 -16 95 -69 134 -27 21 -37 21 -829 23 -725 3
-805 1 -835 -14z"
        />
        <path
          d="M89 4128 c-104 -60 -103 -224 1 -279 33 -18 75 -19 830 -19 755 0
797 1 830 19 105 55 105 221 0 280 -38 21 -41 21 -831 21 -790 0 -794 -1 -830
-22z"
        />
        <path
          d="M952 3233 c-91 -45 -115 -165 -50 -248 44 -57 20 -55 881 -55 l794 0
33 23 c57 38 75 71 75 137 0 63 -16 95 -69 134 -27 21 -37 21 -829 23 -725 3
-805 1 -835 -14z"
        />
      </g>
    </svg>
  )
}
